import { MessageSquare } from "lucide-react";
import { motion } from "framer-motion";

export default function ChatLauncher({ onOpen }) {
  const unread = 1;

  return (
    <motion.button
      onClick={() => {
        navigator.vibrate?.(10);
        onOpen?.();
      }}
      aria-label="Open support chat"

      whileHover={{ scale: 1.06 }}
      whileTap={{ scale: 0.94 }}

      className="
        relative
        w-[52px] h-[52px]
        rounded-full
        flex items-center justify-center
        bg-brand-primary text-white
        shadow-soft
        overflow-hidden
      "
    >

      {/* 🔥 GLOW PULSE */}
      <span
        className="
          absolute inset-0 rounded-full
          bg-brand-primary
          opacity-20
          blur-xl
          animate-pulse
        "
      />

      {/* ICON */}
      <MessageSquare size={20} className="relative z-10" />

      {/* 🔥 UNREAD DOT */}
      {unread > 0 && (
        <motion.span
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.3 }}

          className="
            absolute top-2 right-2
            w-2.5 h-2.5
            rounded-full
            bg-accent-gold
          "
        >
          {/* subtle ping */}
          <span className="absolute inset-0 rounded-full bg-accent-gold opacity-50 animate-ping" />
        </motion.span>
      )}

    </motion.button>
  );
}